import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './theme/shared/shared.module';

import { AppComponent } from './app.component';
import { AdminComponent } from './theme/layout/admin/admin.component';
import { AuthComponent } from './theme/layout/auth/auth.component';
import { NavContentComponent } from './theme/layout/admin/navigation/nav-content/nav-content.component';
import { NavGroupComponent } from './theme/layout/admin/navigation/nav-content/nav-group/nav-group.component';
import { NavCollapseComponent } from './theme/layout/admin/navigation/nav-content/nav-collapse/nav-collapse.component';
import { NavBarComponent } from './theme/layout/admin/nav-bar/nav-bar.component';
import { ConfigurationComponent } from './theme/layout/admin/configuration/configuration.component';

import { ToggleFullScreenDirective } from './theme/shared/full-screen/toggle-full-screen';

/* Menu Items */
import { NgbButtonsModule, NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ListPageComponentComponent } from './demo/list-page-component/list-page-component.component';
import { CustomTableComponent } from './demo/custom-table/custom-table.component';
import { CustomTableModule } from './demo/custom-table/custom-table.module';

import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthModule } from './theme/layout/auth/auth.module';
import { ToastrModule } from 'ngx-toastr';
import { NavigationItem } from './theme/layout/admin/navigation/navigation';
import { NavigationComponent } from './theme/layout/admin/navigation/navigation.component';
import { NavItemComponent } from './theme/layout/admin/navigation/nav-content/nav-item/nav-item.component';
import { NavLeftComponent } from './theme/layout/admin/nav-bar/nav-left/nav-left.component';
import { NavSearchComponent } from './theme/layout/admin/nav-bar/nav-left/nav-search/nav-search.component';
import { NavRightComponent } from './theme/layout/admin/nav-bar/nav-right/nav-right.component';
import { ChatMsgComponent } from './theme/layout/admin/nav-bar/nav-right/chat-msg/chat-msg.component';
import { ChatUserListComponent } from './theme/layout/admin/nav-bar/nav-right/chat-user-list/chat-user-list.component';
import { FriendComponent } from './theme/layout/admin/nav-bar/nav-right/chat-user-list/friend/friend.component';
import { LoadersComponent } from './pages/home/master/loaders/loaders.component';
import { PipeModuleModule } from './pages/home/AMD/pipe-module/pipe-module.module';
import { UserIdleModule } from 'angular-user-idle';
import { navContentService } from './theme/layout/admin/navigation/nav-content/nav-content.service';
import { AuthInterceptorService } from './theme/layout/auth/auth-interceptor.service';

// import { navContentService } from './theme/layout/admin/navigation/nav-content/nav-content.service';
// import { UserIdleModule } from 'angular-user-idle';
// import { AuthInterceptorService } from './theme/layout/auth/auth-interceptor.service';

@NgModule({
  declarations: [
    AppComponent,
    AdminComponent,
    AuthComponent,
    NavigationComponent,
    NavContentComponent,
    NavGroupComponent,
    NavCollapseComponent,
    NavItemComponent,
    NavBarComponent,
    NavLeftComponent,
    NavSearchComponent,
    NavRightComponent,
    ChatUserListComponent,
    FriendComponent,
    ChatMsgComponent,
    ConfigurationComponent,
    ToggleFullScreenDirective,
    ListPageComponentComponent,
    CustomTableComponent,
    
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    SharedModule,
    NgbDropdownModule,
    NgbTooltipModule,
    NgbButtonsModule,
    NgbPaginationModule,
    CustomTableModule,
    FormsModule,
    AuthModule,
    HttpClientModule,
    // LoadersComponent,
    PipeModuleModule,
    // UserIdleModule.forRoot({idle: 1800, timeout: 10, ping: 20}) // 30 min
    UserIdleModule.forRoot({idle: 1200, timeout: 10, ping: 120}),
    ToastrModule.forRoot({
      closeButton: true,
      timeOut: 3000,
      progressBar: true,
      positionClass: 'toast-top-right'}),
    
  ],
  providers: [{ provide: LOCALE_ID, useValue: 'en-US' },NavigationItem,navContentService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true }],
  bootstrap: [AppComponent]
})
export class AppModule { }
